<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <cmp-task-id-select
              ref="taskIdSelect"
              :pageId="pageId"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'all'"
              @select-changed="onChangeBizCodes"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="condType"
              :selected="selectedValues.COD_ROLE_SRCH_COND"
              codeId="COD_ROLE_SRCH_COND"
              :initialSelectedIndex="0"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="condContent"
              maxlength="50"
              @keyup="onKeyUpInput"
              @keyup.enter="onSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMA_00003'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <div class="mrB10" />
      <div class="comm_shut_wrap">
        <div class="inbox">
          <sui-s-grid
            ref="grdLeft"
            :headers="gridColumnsLeft"
            :data-source="dsDataLeft"
            :showRowsPerPageControl="false"
            :options="options"
            @grid:selected="onSelectOriginGrid"
          />          
        </div>
        <div class="btnbox">
          <ul>
            <li>
              <sui-button
                type="button"
                class="comm_btn_shut_right"
                :disabled="btnOrginStatus"
                @click="onClickRight"
              />
            </li>
            <li>
              <sui-button
                type="button"
                class="comm_btn_shut_left"
                :disabled="btnTargetStatus"
                @click="onClickLeft"
              />
            </li>
          </ul>
        </div>
        <div class="inbox">
          <sui-s-grid
            ref="grdRight"
            :headers="gridColumnsRight"
            :data-source="dsDataRight"
            :showRowsPerPageControl="false"
            :options="options"
            @grid:selected="onSelectTargetGrid"
          />
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickClose"
      >
        {{ $t("MSG_BTN_CANCEL") }}
      </sui-button>
      <sui-button
        v-permission:create="'PGE_CMA_00003'"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import {urDataSet} from 'uidev-component/index.js';
export default {
  name: 'PGE_CMA_00003_P01', // eslint-disable-line vue/name-property-casing
  props: {
    pageId: {
      type: String,
      default: null,
    },
    userGroupId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedValues: {
        COD_ROLE_SRCH_COND: {
          label: '',
          key: '',
        },
      },
      // Search Box
      searchBox: {
        COD_PAGE_UE: {
          label: '',
          key: '',
        },
      },
      searchFieldOldText: '',
      selected3rdBizCode: '',
      selectedBizCode: [],
      localdata0: [],
      localdata1: [],
      condContent: '',
      dsDataLeft: new urDataSet(),
      dsDataRight: new urDataSet(),
      options: {
        infinityScroll: true,
        noBaseInfo: false,
        internalPaging: false,
        multiSelect: true,
        selectCheck: true,
      },
      btnOrginStatus: true,
      btnTargetStatus: true,
    };
  },
  computed: {},
  watch: {
    userGroupId(obj) {
      if (obj) {
        this.selectDataFormInput();
      }
    },
  },
  created() {
    this.gridColumnsLeft = [
      {
        text: this.$t('MSG_TXT_TASK_TYPE'),
        value: 'taskName',
      },
      {
        text: this.$t('MSG_TXT_ROLE_ID'),
        value: 'roleId',
        width: 150,
      },
      {
        text: this.$t('MSG_TXT_ROLE_NAME'),
        value: 'roleName',
      },
    ];
    this.gridColumnsRight = [
      {
        text: this.$t('MSG_TXT_TASK_TYPE'),
        value: 'taskName',
      },
      {
        text: this.$t('MSG_TXT_ROLE_ID'),
        value: 'roleId',
        width: 150,
      },
      {
        text: this.$t('MSG_TXT_ROLE_NAME'),
        value: 'roleName',
      },
    ];
  },
  mounted() {
    this.selectDataFormInput();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onReset() {
      this.$refs.condType.reset();
      this.$refs.taskIdSelect.reset();
      this.condContent = '';
    },
    onClickClose() {
      this.$emit('onClickCancel', 'isShownPopupRole');
    },
    onClickSave() {
      this.onSave();
    },
    onSave() {
      const dataParams = {
        userGroupRoleList: this.dsDataRight.data,
        // userGroupRoleDeleteList: this.dsDataTemp.data,
      };

      http.request(this.pageId, 'DTS_CMA_00016', {
        data: dataParams,
        path: {
          'user-group-id': this.userGroupId,
        },
      }).then(() => {
        this.$emit('onRowReSelect');
        this.onClickClose();
      }).catch(error => {
        console.log(error);
      });
    },
    onConfirmCancel() {
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onSearch() {
      let taskId = '';
      // 구분 코드
      if (this.selectedBizCode.length === 3) {
        if (this.selectedBizCode[2].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[2].key);
        } else if (this.selectedBizCode[1].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[1].key);
        } else if (this.selectedBizCode[0].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[0].key);
        }
      }

      const condTypeCode = this.selectedValues.COD_ROLE_SRCH_COND.key;
      const queryParams = {
        taskId: taskId || '',
        searchCond: condTypeCode || '',
        searchWord: this.condContent || '',
      };

      http.request(this.pageId, 'DTS_CMA_00001', {
        query: queryParams,
      }).then(res => {
        if (res.data) {
          this.dsDataLeft.setData(res.data);
          // const saveData = [];
          // utils.forEach(res.data, obj => {
          //   if (this.isExistData(this.dsDataRight.data, obj.roleId) === false) {
          //     const objData = {
          //       roleId: utils.trim(obj.roleId),
          //       roleName: utils.trim(obj.roleName),
          //       taskId: utils.trim(obj.taskId),
          //       taskName: utils.trim(obj.taskName),
          //       roleContent: utils.trim(obj.roleContent),
          //       roleNickName: utils.trim(obj.roleNickName),
          //       finalModificationUserId: utils.trim(obj.finalModificationUserId),
          //       finalModificationDTM: utils.trim(obj.finalModificationDTM),
          //     };
          //     saveData.push(objData);
          //   }
          // });

          // this.dsDataLeft.setData(saveData);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onClickRight() {

      if (this.dsDataLeft.data.length > 0) {
        const selectedData = this.dsDataLeft.getSelected();
        utils.forEach(selectedData, item => {
          if (!this.isExistData(this.dsDataRight.data, item)) {
            this.dsDataRight.addRow({
              roleId: utils.trim(item.roleId),
              roleName: utils.trim(item.roleName),
              taskId: utils.trim(item.taskId),
              taskName: utils.trim(item.taskName),
            });
          }
        });
        this.$refs.grdLeft.resetSelect();
        this.$refs.grdRight.resetSelect();
      }
    },
    onClickLeft() {
      const selected = this.dsDataRight.getSelected();
      utils.forEach(selected, item => {
        this.dsDataRight.removeRow(item, false);
      });
      this.$refs.grdRight.resetSelect();
    },
    onKeyUpInput() {
      const searchFieldNewText = this.condContent;

      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.condContent = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    onClose() {
      console.log('close');
    },
    selectDataFormInput() {
      http.request(this.pageId, 'DTS_CMA_00011', {
        path: {
          'user-group-id': this.userGroupId,
        },
      }).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.dsDataRight.setData(res.data);
          } else {
            this.dsDataRight.setData([]);
          }
        }
      }).catch(error => {
        console.log(error);
      });
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
    isExistData(dataList, selectedData) {
      const isExist = _.some(dataList, { 
        roleId: selectedData.roleId,
      });
      return isExist;
    },
    onSelectOriginGrid(row) {
      if (!utils.isEmpty(row)) {
        this.btnOrginStatus = false;
      } else {
        this.btnOrginStatus = true;
      }
    },
    onSelectTargetGrid(row) {
      if (!utils.isEmpty(row)) {
        this.btnTargetStatus = false;
      } else {
        this.btnTargetStatus = true;
      }
    },
  },
};
</script>
<style scoped>
</style>
